import {environment} from '../../environments/environment';

export class ILangdict {
  pl: string;
  en?: string;
}

export class Langdict extends ILangdict {

  constructor(obj: ILangdict) {
    super();
    this.pl = obj.pl;
    this.en = obj.en;
  }

  public toString() {
    if (environment.lang === 'pl') {
      return this.pl;
    }
    if (this.en && this.en !== '') {
      return this.en;
    }
    return '(in Polish) ' + this.pl;
  }

  public toStringWithNewlines() {
    let value = this.toString();
    value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    return value;
  }
}
